import { setupWorker } from 'msw';
import Resolvers from './resolvers';

export const worker = setupWorker(...Resolvers);
